import * as React from 'react';

export interface IRootProps<
  E extends HTMLElement
> extends React.AllHTMLAttributes<HTMLElement> {
  tagName: keyof React.ReactHTML;
  innerRef?: React.Ref<HTMLElement>;
}

export class RootRenderer<E extends HTMLElement = HTMLDivElement> extends React.PureComponent<IRootProps<E>> {
  static defaultProps = { tagName: 'div' as keyof React.ReactHTML };

  render() {
    const { tagName, children, innerRef, ...props } = this.props;
    return React.createElement(tagName, { ref: innerRef, ...props }, children);
  }
}
